var textwen = false;
var updateVariantInfoobj = {};
var noteData = [];
var responsedatalist = [];
var perlabels = "/unit";
var quoteCode = "";
var pricediscount = "";
var isProductType = "";
var manuscriptDiy = "";
var isInstructionsTip = true;
var newCupsIdListFile = [];
var productVarId = "";
var paperCupId = "";
var templateType = "";
var textInfo=[]
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
var backgroundColor = "#FEC629";
var UploadProductType = {
  UploadProductType: {},
};
var isaddcart = false;
var isdiy = false;
var quoteParamNew = {};
var getQuoteMetaField = {};
var newCupsIdListFileList = [];
var orderObjList = {
  noteId: "",
  //1:olderNote,2:newNote
  type: "1",
  token: "",
  customeremail: "",
  customerId: "",
};
var stickersLabels = "";
var stickersLabelsType = {};
var isShowisInstructionsTipFun = false;
var dieCutRusultData = {
  data: null,
  clearData: null,
};
var productNewDetailLoadTime = 0;
function uploadSuccess() {
  sendGAEvent("artwork_upload_success", {
    category: "user_action",
    label: "artwork_upload_success",
  });
}
function artwork_choose_file_click() {
  sendGAEvent("artwork_choose_file_click", {
    category: "user_action",
    label: "artwork_choose_file_click",
  });
}
function gtag_report_conversion_design(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-11458615515/SyIOCNXalo8aENux8tcq',
      'event_callback': callback
  });
  gtag('event', 'conversion', {
      'send_to': 'AW-11458615515/1rmSCPrli6MaENux8tcq',
      'event_callback': callback
  });
  return false;
}
$(".uploadPropInputDiy,.uploadImgDiy,.uploadImgDiyA,.uploadImgDiyB").click(
  function () {
    artwork_choose_file_click();
  }
);
$(document).ready(function () {
  $(window).on("pageshow", function (event) {
    if (
      event.persisted ||
      (window.performance && window.performance.navigation.type === 2)
    ) {
      location.reload();
    }
  });
});
$(".calendarUpload").click(function () {
  $(".loadingCalend").css("display", "block");
  var waistposition = $(".newproductselectfirstchildSize").attr(
    "waistposition"
  );
  var obj = {
    type:
      waistposition.indexOf("Middle") >= 0
        ? "middlewallcalendar"
        : $(this).attr("type"),
    id: $(this).attr("productid"),
    month: updateVariantInfoobj.month,
    quoteId: updateVariantInfoobj.quoteId,
    code: updateVariantInfoobj.code,
    size: newsize().width + "x" + newsize().height,
    titleName: $(".product__titleh1").text(),
  };
  obj.size = obj.size.replace(/\s/g, "");
  var data = {
    productId: obj.id,
    month: updateVariantInfoobj.month,
    quoteId: updateVariantInfoobj.quoteId,
    code: updateVariantInfoobj.code,
  };
  $.ajax({
    url: newlocaURLsaveProduct,
    type: "POST",
    contentType: "application/json",
    data: JSON.stringify(data),
    async: false,
    success: function (response) {
      if (response.code == 200 && response.result == "success") {
        obj.variantId = response.data.variantId;
        var newGetQuoteMetaFieldO = {};
        var newGetQuoteMetaField = $(".newGetQuoteMetaField");
        newGetQuoteMetaField.map((res) => {
          if (
            $(newGetQuoteMetaField[res]).attr("class").indexOf("active") >= 0
          ) {
            var key = $(newGetQuoteMetaField[res]).attr("customerTypeName");
            var values = $(newGetQuoteMetaField[res]).attr("customerval");
            newGetQuoteMetaFieldO[key] = values;
          }
        });
        var data = {
          data: obj,
          responsedatalist: responsedatalist,
          newGetQuoteMetaFieldO: newGetQuoteMetaFieldO,
        };
        sessionStorage.setItem("calendar", JSON.stringify(data));
        jumpToShoppingCancel();
        // setTimeout(re=>{
        //   location.reload()
        // },500)
      } else {
        tipShow(response.message);
      }
      $(".loadingCalend").css("display", "none");
    },
  });
});
document.addEventListener("DOMContentLoaded", function() {
    // 在这里编写需要在元素加载完成后执行的代码
    $('.material-icons').css('opacity','1')
});
function loadEdit() {
  var $targetElement = $(".new-product-addtab-rff");
    var $section = $targetElement.closest("section");

    // 将目标元素移动到 section 的上方
    $targetElement.insertBefore($section);
  // if ($(".product__titleh1").text().indexOf("Sticker") >= 0) {
  //   perlabels = " stickers";
  // } else if ($(".product__titleh1").text().indexOf("Cups") >= 0) {
  //   perlabels = " cups";
  // } else if ($(".product__titleh1").text().indexOf("Bags") >= 0) {
  //   perlabels = " bags";
  // } else {
  //   perlabels = $(".productLastChildWord").text()
  //     ? " " + $(".productLastChildWord").text()
  //     : " labels";
  // }
  quoteCode = $(".isquoteBat").text();
  pricediscount = $(".pricediscount").text();
  isProductType = $(".isProductType").text();
  orderObjList.customeremail = $(".emOrder").text();
  orderObjList.customerId = $(".customerId").text();
  stickersLabels = $(".stickersLabels").text();
  if (isProductType == 1) {
    $(".customSize").css("display", "none");
  }
  if ($(".UploadProductType")) {
    UploadProductType.UploadProductType.name = $(".UploadProductType")
      .text()
      .split("-")[0];
    UploadProductType.UploadProductType.type = $(".UploadProductType")
      .text()
      .split("-")[1]
      ? $(".UploadProductType").text().split("-")[1]
      : "";
    if (UploadProductType.UploadProductType.name == "handbag") {
      $(".choose-bg-style").css("display", "none");
    }
  }
  if (
    $(".product__titleh1").text() == "Transfer Sticker-Deals" &&
    document.body.clientWidth > 750
  ) {
    $(".installment").insertAfter(".newComparable1");
    $('.caption-large').css('opacity','1')
    $(".timegMobilepc2").insertAfter(".new-racetopprintMobole");
  } else {
    $(".installment").insertAfter(".newComparable1");
    $('.caption-large').css('opacity','1')
  }
  manuscriptDiy = $(".manuscriptDiy").text();
  $.ajax({
    url: newlocaURLevaluationgetQuoteMetaField,
    type: "get",
    contentType: "application/json",
    data: {
      quoteCode: quoteCode,
    },
    success: function (response) {
      if (response.code == 200) {
        if (response.data) {
          renderOption(response);
        } else {
          $(".new-product-Size-ProductSize").css("width", "100%");
        }
        cust();
      } else {
        tipShow(response.message);
      }
    },
  });
  //banner tab
  var thumbnailList=$('.thumbnail-list li')
  var str=''
  thumbnailList.map(res=>{
    if(res==0){
      str+='<span class="active"></span>'
    }else{
      str+='<span></span>'
    }
  })
  $('.productTabBanner').html(str)
  $('.thumbnail-list__item').click(function(){
    $('.productTabBanner .active').removeClass('active')
    $($('.productTabBanner span')[$(this).index()]).addClass('active')
  })
  $('.productTabBanner').on('click',' span',function(){
    $($('.thumbnail-list__item')[$(this).index()]).children().click()
  })
}

function removeTrailingZero(num) {
  var numStr = num.toString();
  var newNumStr = numStr.replace(/(\.\d*)0+$/, monetaryUnit.unit + "1");
  return Number(newNumStr);
}

function tipText() {
  var str = "Please enter the size  and quantity";
  if (
    $(".newproductselectfirstchildSize").attr("value").indexOf("custom") >= 0
  ) {
    if (!$(".sizewidth").val() || !$(".sizeheight").val()) {
      str = "Please enter the size";
    }
  }
  if ($(".newproductselectfirstchildQuantity").text().indexOf("custom") >= 0) {
    if (!$(".customQuantitysale").val()) {
      str = "Please enter the size";
    }
  }
  if (
    $(".newproductselectfirstchildSize").attr("value").indexOf("custom") >= 0 &&
    $(".newproductselectfirstchildQuantity").text().indexOf("custom") >= 0
  ) {
    if (
      !$(".sizewidth").val() &&
      !$(".sizeheight").val() &&
      !$(".customQuantitysale").val()
    ) {
      str = "Please enter the size  and quantity";
    }
  }
  return str;
}

const anchorLinks = document.querySelectorAll('a[href^="#"]');

anchorLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();

    const targetId = link.getAttribute("href");

    const targetElement = document.querySelector(targetId);

    targetElement.scrollIntoView({
      behavior: "smooth",

      block: "start",
    });
  });
});

function productPingxingshuju() {
  var num = Math.ceil($(".productPingxingshuju>div").length / 5);

  var str = "";
  let i = 1;

  while (i <= num - 1) {
    str += "<span>" + i + "</span>";

    i++;
  }

  $(".productPingxingshujuye").html(str);

  $(".productPingxingshujuye span:first-child").addClass("active");

  $(".productPingxingshujuye span").click(function () {
    $(".productPingxingshujuye .active").removeClass("active");

    $(this).addClass("active");

    $(".productPingxingshuju>div").css("display", "none");

    $(
      ".productPingxingshuju>div:nth-child(n+" +
        (($(this).text() - 1) * 5 + 1) +
        "):nth-child(-n+" +
        $(this).text() * 5 +
        ")"
    ).css("display", "flex");
  });
}
function EvaluationcontentSwiper(text, num, initialSlide) {
  var swiper = new Swiper(text, {
    slidesPerView: num,

    spaceBetween: 30,

    initialSlide: initialSlide ? initialSlide : 0,

    pagination: {
      el: ".swiper-pagination1",

      clickable: true,
    },

    navigation: {
      nextEl: ".swiper-button-next",

      prevEl: ".swiper-button-prev",
    },
  });
}



function isdiscountavailable() {
  var saleNum =
    $('select[name="options[Quantity]"]').val() == "custom"
      ? $(".customQuantitysale").val()
      : $('select[name="options[Quantity]"]').val();

  var selectz = $('select[name="options[Quantity]"]').children();

  var zhekou = "";

  selectz.map((res) => {
    if ($(selectz[res]).attr("value") == saleNum) {
      zhekou = $(selectz[res])
        .text()
        .replace(/\s/g, "")
        .split("%")[0]
        .split("%")[0]
        .substr(-2);
    }
  });

  if (zhekou) {
    $(".isdiscountavailable").text("Save " + zhekou + "%");
  } else {
    $(".isdiscountavailable").text(
      $(".isdiscountavailable").attr("isdiscountavailable")
    );
  }

  $(".isdiscountavailable").css("display", "block");

  if ($(".newpricezOriginal").text().indexOf("N") >= 0) {
    $(".newpricezOriginal").css("display", "none");
  }
}

function editUpload() {
  $(".uploadDesign").css("background", backgroundColor);
  $(".uploadDesign").css("pointer-events", "initial");
  $(".calendarUpload").css("background", backgroundColor);
  $(".calendarUpload").css("pointer-events", "initial");
  $(".diy").css("background", "#F2F2F2");
  $(".diy").css("pointer-events", "initial");
  $(".ContinueFunzIdfinished").css("background", backgroundColor);
  $(".ContinueFunzIdfinished").css("pointer-events", "initial");
}

function pointerUpload() {
  $(".uploadDesign").css("background", "#ddd");
  $(".uploadDesign").css("pointer-events", "none");
  $(".calendarUpload").css("background", "#ddd");
  $(".calendarUpload").css("pointer-events", "none");
  $(".diy").css("background", "#ddd");
  $(".diy").css("pointer-events", "none");
  $(".ContinueFunzIdfinished").css("background", "#ddd");
  $(".ContinueFunzIdfinished").css("pointer-events", "none");
}
function cust() {
  var sizewidth = newsize().sizewidth;
  var width = newsize().width;
  var height = newsize().height;
  var saleNum = newsize().saleNum;

  var custonSize = {};
  if (isProductType == 1) {
    custonSize = {
      saleNum: saleNum,
      quoteCode: quoteCode,
      factorCode: pricediscount,
      size: $(".newproductselectfirstchildSize").attr("value"),
      member: $(".emOrder").text(),
      diyProps: {},
    };
  } else {
    custonSize = {
      saleNum: saleNum,
      inchLen: height,
      inchWid: width,
      quoteCode: quoteCode,
      factorCode: pricediscount,
      member: $(".emOrder").text(),
      diyProps: {},
    };
  }
  var newGetQuoteMetaField = $(".newGetQuoteMetaField");
  var objData = "";
  newGetQuoteMetaField.map((res) => {
    if ($(newGetQuoteMetaField[res]).attr("class").indexOf("active") >= 0) {
      if (
        $(newGetQuoteMetaField[res]).attr("customertypename") == "Color" ||
        $(newGetQuoteMetaField[res]).attr("customertypename") == "Cover Paper"||$(newGetQuoteMetaField[res]).attr("customertypename") == "Cover"
      ) {
        var type = $(newGetQuoteMetaField[res]).attr("customerval").split('+')[0];
        var obj = {
          White: "whitePaper",
          Brown: "yellowPaper",
          Black: "blackPaper",
          Hardcover: "hard",
          Softcover: "soft",
        };
        UploadProductType.UploadProductType.type = obj[type];
      }
      if ($(newGetQuoteMetaField[res]).attr("meaning") == "diyPropColor") {
        UploadProductType.UploadProductType.diyPropColor = $(
          newGetQuoteMetaField[res]
        ).attr("customerval");
        UploadProductType.UploadProductType.diyPropColorVal = $(
          newGetQuoteMetaField[res]
        ).children('i').css('background-color');
      }
      if (
        $(newGetQuoteMetaField[res]).attr("customertypename") == "Coil color"
      ) {
        var type = $(newGetQuoteMetaField[res]).attr("customerval");
        var obj = {
          White: "white",
          Black: "black",
        };
        UploadProductType.UploadProductType.spiralColor = obj[type];
      }
      if ($(newGetQuoteMetaField[res]).attr("customertypename") == "Material") {
        var type = $(newGetQuoteMetaField[res]).attr("customerval");
        UploadProductType.UploadProductType.type = type.split(" ")[0];
      }
      if ($(newGetQuoteMetaField[res]).attr("customertypename") == "Bag Colors") {
        var type = $(newGetQuoteMetaField[res]).attr("customerval");
        UploadProductType.UploadProductType.BagColors = type.split(" ")[0];
      }
      var key = $(newGetQuoteMetaField[res]).attr("meaning");
      var values = $(newGetQuoteMetaField[res]).attr("customerval");
      var meaning = $(newGetQuoteMetaField[res]).attr("meaning");
      if (meaning.indexOf("diyProp") >= 0) {
        custonSize.diyProps[meaning] = $(newGetQuoteMetaField[res]).text();
      } else {
        custonSize[key] = values;
      }
      var key1 = $(newGetQuoteMetaField[res]).attr("customerTypeName");
      objData +=
        '<input type="text" name="properties[' +
        key1 +
        ']" value="' +
        values +
        '" style="display: none; opacity: 1;" />';
    }
  });
  $(".newForm").html(objData);
  quoteParamNew = JSON.parse(JSON.stringify(custonSize));

  var arr = [];

  var newQuantityQuantity = $(".newproductselectdivQuantity>div");
  newQuantityQuantity.map((res) => {
    var obj = JSON.parse(JSON.stringify(custonSize));
    obj.currency = monetaryUnit.currency;
    obj.title = $(".product__titleh1").text();
    if ($(newQuantityQuantity[res]).text().indexOf("custom") < 0) {
      obj.saleNum = parseInt($(newQuantityQuantity[res]).attr("value"));
      arr.push(obj);
    } else {
      if ($(".customQuantitysale").val()) {
        obj.saleNum = parseInt($(".customQuantitysale").val());
        arr.push(obj);
      } else {
        setTimeout((re) => {
          $(".customQuantitysale").val("");
        }, 200);
      }
    }
  });
  isdiy = false;
  pointerUpload();
  $(".loadingQuantity").css("display", "block");
  // $('.newproductselectdivQuantity1').css('display','none')
  $(".newproductselectfirstchildSize").css("pointer-events", "none");
  $(".newproductselectdivQuantity").css("pointer-events", "none");

  if (width > 0 && height > 0) {
    $(".newproductselectfirstchildSize").css("pointer-events", "initial");
    $(".newproductselectdivQuantity").css("pointer-events", "initial");
    $.ajax({
      url: newlocaURLcustom,

      type: "POST",

      contentType: "application/json",

      data: JSON.stringify(arr),

      success: function (response) {
        if (response.result == "success") {
          var isupdateVariantInfoobj = true;
          responsedatalist = response.data;
          var responsedata = response.data[0];
          var numz = $(".newproductselectdivQuantity .active").index();
          numz=numz>4?numz-1:numz
          if (numz >= 0) {
            if (numz == responsedatalist.length) {
              if ($(".customQuantitysale").val()) {
                responsedata = response.data[numz];
              } else {
                isupdateVariantInfoobj = false;
                setTimeout((re) => {
                  $($(".newproductselectdivQuantity>div")[numz]).click();
                }, 30);
              }
            } else {
              responsedata = response.data[numz];
            }
          } else {
            // if (window.document.body.clientWidth < 750) {
            //   $(".newproductselectdivQuantity div:nth-child(2)").addClass(
            //     "active"
            //   );
            //   if (response.data[1]) {
            //     responsedata = response.data[1];
            //   }
            // } else {
              $(".newproductselectdivQuantity div:first-child").addClass(
                "active"
              );
            // }
            $(".newproductselectfirstchildQuantity>p").text(
              $(".newproductselectdivQuantity .active").attr("value")
            );
          }
          if (responsedata&&!responsedata.code) {
            var num = 0;
            response.data.map((res) => {
              if (res.code) {
                responsedata = res;
                num++;
              }
            });
            if (num == 0) {
              tipShow("Failed to obtain quotation, please requote");
              isupdateVariantInfoobj = false;
              $(".newpricez").text("");
              $(".isdiscountavailablenewpricezPrice").text("");
              $(".isdiscountavailable").text("");
              $(".newproductselectfirstchildQuantity li").css(
                "display",
                "none"
              );
              $(".newproductselectdivQuantity div li").css("display", "none");
              return false;
            }
          }
          if (isupdateVariantInfoobj) {
            var num = 0;
            response.data.map((re, index) => {
              var price = re.price / re.saleNum;
              if (num < price) {
                num = price;
              }
            });
            response.data.map((re, index) => {
              if (re.code) {
                $(newQuantityQuantity[index])
                  .find(".newproductselectdivQuantitypspan")
                  .remove();
                var price = re.price / re.saleNum;
                $(newQuantityQuantity[index])
                  .find(".newproductselectdivQuantityp")
                  .remove();
                $(newQuantityQuantity[index])
                  .find("li")
                  .append(
                    '<p class="newproductselectdivQuantityp">' +
                      monetaryUnit.unit +
                      newCurrency(re.price,1) +
                      "</p>"
                  );
                    var pricea=$(newQuantityQuantity[index]).find('.newproductselectdivQuantityp').text().replace(/\D/g, '');
                  if (
                    $(newQuantityQuantity[index]).text().indexOf("custom") >= 0
                  ) {
                    $(newQuantityQuantity[index]).find('li').append('<span class="newproductselectdivQuantitypspan">'+monetaryUnit.unit+newCurrency(pricea/$(newQuantityQuantity[index]).find('input').val(),100)+'/unit</span>')
                  } else {
                    $(newQuantityQuantity[index])
                      .find("li").append('<span class="newproductselectdivQuantitypspan">'+monetaryUnit.unit+newCurrency(pricea/$(newQuantityQuantity[index]).attr('value'),100)+'/unit</span>');
                    // $(newQuantityQuantity[index]).find('.newproductselectdivQuantityp').before('<span class="newproductselectdivQuantitypspan">'+monetaryUnit.unit+newCurrency(pricea/$(newQuantityQuantity[index]).attr('value'),100)+'/unit</span>')
                  }
                  if (num != price) {
                    $(newQuantityQuantity[index])
                      .find(".newproductselectdivQuantitypper")
                      .remove();
                    var discountNum = (((num - price) / num) * 100).toFixed(2);
                    var limitDiscountNum = 5;
                    var lowDiscountFlag = discountNum < limitDiscountNum;
                    $(newQuantityQuantity[index])
                      .find("li")
                      .append(
                        `<p class="newproductselectdivQuantitypper${
                          lowDiscountFlag ? " low-discount-class" : ""
                        }">-` +
                          (((num - price) / num) * 100).toFixed(2) +
                          "%</p>"
                      );
                    $(newQuantityQuantity[index])
                      .find(".DiscountnewproductselectdivQuantitypper")
                      .remove();
                    $(newQuantityQuantity[index])
                      .find("li")
                      .append(
                        '<p class="DiscountnewproductselectdivQuantitypper">' +
                          monetaryUnit.unit +
                          (removeTrailingZero(re.price) / 0.7).toFixed(2) +
                          "</p>"
                      );
                  } else {
                    $(newQuantityQuantity[index])
                      .find(".DiscountnewproductselectdivQuantitypper")
                      .remove();
                    $(newQuantityQuantity[index])
                      .find("li")
                      .append(
                        '<p class="DiscountnewproductselectdivQuantitypper">' +
                          monetaryUnit.unit +
                          (removeTrailingZero(re.price) / 0.7).toFixed(2) +
                          "</p>"
                      );
                  }
                $(newQuantityQuantity[index])
                  .find("li")
                  .css("display", "block");
                if(index<5){
                  $(newQuantityQuantity[index]).css("display", "block");
                }else{
                  $(newQuantityQuantity[index]).attr('code',re.code)
                }
              } else {
                $(newQuantityQuantity[index]).css("display", "none");
              }
            });
            //如果节省的百分比有一个比上一个小的，隐藏全部的节省的百分比显示
            var newproductselectdivQuantitypperList=$('.newproductselectdivQuantitypper')
            newproductselectdivQuantitypperList.map(res=>{
              if(res>0&&res<newproductselectdivQuantitypperList.length){
                //当前的折扣
                var currentDiscount=$(newproductselectdivQuantitypperList[res]).text().replace(/[^0-9.]/g, '')
                //上一个折扣
                var prevDiscount=$(newproductselectdivQuantitypperList[res-1]).text().replace(/[^0-9.]/g, '')
                if(+prevDiscount>+currentDiscount){
                  $('.newproductselectdivQuantitypper').css('display','none')
                }
              }
            })
            if ($(".customQuantitysale").val() > 0) {
              $(".newproductselectdivQuantity1").css("display", "block");
            } else {
              $(".newproductselectdivQuantity1").css("display", "none");
            }
            updateVariantInfoobj.month = responsedata.month;
            updateVariantInfoobj.quoteId = responsedata.id;
            updateVariantInfoobj.saleNum = responsedata.saleNum;
            updateVariantInfoobj.code = responsedata.code;
            var list = $(".newproductselectdivQuantity").children();
            list.map((res) => {
              if ($(".newproductselectfirstchildQuantity>p").text() ==$(list[res]).attr("value")) {
                $(".newproductselectdivQuantity").prev().html($(list[res]).html());
              }
            });
            // var pricediscount = $('.pricediscount').text().split(')-')
            var price = +responsedata.price;
            var coefficient = 1;
            var prices = ((price * coefficient).toFixed(2) * 1).toFixed(2);
            var COUPON = {
              us: {
                limit: 79,
                reduce: 20,
                enabled: false,
                discountPrice: prices,
                currency: { us: "$", ca: "CA$" }[region],
              },
              ca: {
                limit: 120,
                reduce: 30,
                enabled: false,
                discountPrice: prices,
                currency: { us: "$", ca: "CA$" }[region],
              },
            };
            /** 新年活动券，limit使用限制最低金额，reduce满减多少 */
            var NY20_COUPON = COUPON[region || "us"];
            if (prices >= NY20_COUPON.limit) {
              NY20_COUPON.discountPrice = prices - NY20_COUPON.reduce;
              NY20_COUPON.enabled = true;
            } else {
              NY20_COUPON.enabled = false;
            }
            Alpine.$data(document.querySelector("#main-prod-coupon")).show =
              NY20_COUPON.enabled;
            var coefficient = getProductCoefficient();
            $(".newpricez").text(monetaryUnit.unit + newCurrency(prices * coefficient, 1));
            if (coefficient < 1) {
              $('.under-line-price').text(monetaryUnit.unit + newCurrency(prices, 1,true));
            }
            if (NY20_COUPON.enabled) {
              Alpine.$data(document.querySelector("#main-prod-coupon")).price =
                newCurrency(NY20_COUPON.discountPrice, 1);
            } else {
              Alpine.$data(document.querySelector("#main-prod-coupon")).price =
                newCurrency(prices, 1);
            }
            newpricezOriginalnew(price);
            $(".isdiscountavailablenewpricezPrice").text(
              monetaryUnit.unit + newCurrency(price / 0.7, 1)
            );
            edittipJustHolidayNew(price)
            $(".isdiscountavailable").text(
              monetaryUnit.unit +
                newCurrency(prices / newsize().saleNum, 1) +
                // " per " +
                perlabels
            );
            $(".isdiscountavailable").css("display", "block");

            $(".quantityvalue").val(newCurrency(price * coefficient, 1) * 1);

            $(".quantityvaluewidth").val(width);

            $(".quantityvalueheight").val(height);

            $(".quantityvaluesaleNum").val(saleNum);

            var data = {
              code: responsedata.code,

              id: responsedata.id,

              month: responsedata.month,
            };

            $(".notequtez").val(JSON.stringify(data));
            $(".no-js-hidden1").css("display", "none");

            $(".newpricez").css("display", "block");

            var num = $(".isdiscountavailable").text().replace("Save", "");

            $(".newpricezOriginal").text(
              monetaryUnit.unit +
                (
                  +(price * coefficient) /
                  ((100 - parseInt(num)) / 100)
                ).toFixed(1) +
                "0"
            );

            if ($(".newpricezOriginal").text().indexOf("N") >= 0) {
              $(".newpricezOriginal").css("display", "none");
            }

            isdiy = true;
            editUpload();

            editpipei(width, height, saleNum);

            var arr = $('select[name="options[Quantity]"] option');
            if (arr.length) {
              arr.map((res) => {
                var str = $(arr[res])
                  .text()
                  .split("%")[0]
                  .replace("·", "")
                  .replace("save", "")
                  .replace(/\s*/g, "");

                if (str != "custom") {
                  function getLastTwoChars(str) {
                    return str.slice(-2);
                  }

                  var result = getLastTwoChars(str);

                  var strz =
                    str.split(result)[0] +
                    "&nbsp;&nbsp;·&nbsp;&nbsp; save " +
                    result +
                    "%";

                  strz = strz.replace("x2", "&nbsp;&nbsp;x2");

                  $(arr[res]).html(strz);
                }
              });
            }
            editExtrastickersli();
          }
          editBorderRadius()
          $(".loadingQuantity").css("display", "none");
          if (productNewDetailLoadTime > 0) {
            productNewDetailLoadTime = +new Date() - productNewDetailLoadTime;
            if (!window.gtag) return
            window.gtag("event", "product_load_time", {
              product_load_time: productNewDetailLoadTime,
              value: productNewDetailLoadTime,
            });
            productNewDetailLoadTime = 0;
          }
        } else {
          tipShow(response.message);
        }
      },

      error: function (xhr, status, error) {},
    });
  }
}
function editBorderRadius(){
  $('.materialxuanze').css('display','none')
  $('.forma2Select').css('border-radius','15px')
  $('.materialxuanze1').css('display','none')
  $('.format2Finish').css('border-radius','15px')
  $('.newproductselectdivSize').css('display','none')
  $('.newproductselectSize').css('border-radius','15px')
}
$('.newproductselectfirstchildul').click(function(){
  $('.newproductselectdivQuantityP').parent().css('display','block')
  var nextAllEleme=$(this).nextAll()
  nextAllEleme.map(res=>{
    if($(nextAllEleme[res]).attr('code')){
      $(nextAllEleme[res]).css('display','block')
    }
  })
  $(this).css('display','none')
})
function newpricezOriginalnew(price) {
  var product = $("input[name='product-id']").val();
  var num = 1;
  if (product == 8807290175740) {
    num = 0.5;
  } else if (product == 8807297483004 || product == 8807298695420) {
    num = 0.6;
  }
  if (num != 1) {
    $(".newpricezOriginalnew").text(
      monetaryUnit.unit + newCurrency(price / num, 1)
    );
    $(".newpricezOriginalnew").css("display", "block");
  }
}
function tipShow(text) {
  $(".tip").text(text);

  $(".tip").css("display", "block");

  setTimeout((res) => {
    $(".tip").css("display", "none");
  }, 2000);
}

function newsize() {
  var sizewidth = $(".sizewidth").val();
  var width =
    isProductType == 1
      ? 1
      : $(".newproductselectfirstchildSize").attr("value") == "custom"
      ? sizewidth
      : $(".newproductselectfirstchildSize").text().split("x")[0].split('"')[0];
  var height =
    isProductType == 1
      ? 1
      : $(".newproductselectfirstchildSize").attr("value") == "custom"
      ? $(".sizeheight").val()
      : $(".newproductselectfirstchildSize").text().split("x")[1].split('"')[0];
  var saleNum =
    $(".newproductselectdivQuantity .active").text().indexOf("custom") >= 0
      ? $(".customQuantitysale").val()
      : $(".newproductselectfirstchildQuantity>p").text();

  var quantityvalue = $(".quantityvalue").val();

  var materialInput = $(".materialInput").val();
  var Finish = $(".Finish").val();
  var format = $(".format").val();
  var productTypeColor = $(".productTypeColor").val();
  return {
    sizewidth: sizewidth,

    width: width,

    height: height,

    saleNum: saleNum,

    quantityvalue: quantityvalue,

    materialInput: materialInput,
    Finish: Finish,
    productTypeColor: productTypeColor,
    format: format,
  };
}

function edittitle() {
  var emalurlstr = $(".emalurl").text().split(",");

  var str = $(".subtitlez").text();

  emalurlstr.map((res) => {
    str = str.replace(
      res,
      "<a href='mailto:support@racetopprint.com'>" + res + "</a>"
    );
  });

  $(".subtitlez").on("click", "span", function () {
    $(".subtitlez").height("auto");

    $(this).css("display", "none");
  });
}

function copyBtn() {
  var textToCopy = $("#copyBtn").attr("code");

  var tempInput = document.createElement("textarea");

  tempInput.value = textToCopy;

  document.body.appendChild(tempInput);

  tempInput.select();

  document.execCommand("copy");

  document.body.removeChild(tempInput);
}

function editpipei(width, height, saleNum) {
  $(".pipeijiage").css("display", "none");

  var pipei = $(".pipei")
    .text()
    .replace(/\s+/g, "")
    .replace(/<[^>]+>/g, "");

  var pipeia = pipei.split("-]");

  var pinpainame = $(".pinpaiming").text().split("-");

  var pinpaijieshao = $(".pinpaijieshao").text();

  pipeia.map((res) => {
    var a = res.split("-");

    a.map((r) => {
      var st = (width + "x" + height + "x" + saleNum).replace(/\s+/g, "");

      if (r == st) {
        $(".pipeijiage").html(
          "<p>" +
            pinpaijieshao +
            "</p><span>" +
            pinpainame[0] +
            ":" +
            monetaryUnit.unit +
            a[1] +
            "</span><span>" +
            pinpainame[1] +
            ":" +
            monetaryUnit.unit +
            a[2] +
            "</span>"
        );
      }
    });
  });
}

function product__titleh1() {
  // $('.isdiscountavailablenewpricez').before($('.swiperTMobile'))

  // var html = ''
  // html =
  // 	'<div class="newComparable"><div><div>Comparable Quality That Cost You <p>25% Less</p></div><div>Full Refund If Unsatisfied, No Questions Asked</div></div></div>'
  // $('.swiperTMobile').after(html)

  $(".new-page-width-product").css("padding", "0");

  $(".subtitlez").css("padding", "0 1rem");

  $(".subtitlez").css("margin-top", "0px");


  $(".Evaluationcontentp").css("display", "flex");


  // $(".isdiscountavailablenewpricez").css("padding", "0 1rem");

  // $('.isdiscountavailablenewpricez').css('background', '#F4F4F4')

  $(".no-js-hidden").css("margin-top", "-10px");

  $(".no-js-hidden").css("padding-top", "10px");

  $(".pipeijiage").css("margin", "0");

  $(".pipeijiage").css("background", "#fff");

  $(".pipeijiage").css("padding", "10px");

  $(".uploadMobile").css("margin", "0 1rem");

  $(".uploadMobile").css("width", "calc(100% - 2rem)");

  $(".uploadMobile").css("color", "#000000");

  $(".designMobile").css("border", "none");

  $(".quick-add-hidden").css("margin", "1rem");

  $(".Rounded-Cornera1").css("margin", "1rem");

  $(".newComparable>div").css("margin-bottom", "0");

  $(".Evaluationcontent+.newComparable").remove();

  $(".isdiscountavailable").addClass(" afterz");

  // $('.isdiscountavailable').css('background','#45B821')

  $(".timegMobile").css("margin-top", "-15px");

  $(".product__accordion").css("display", "none");
}
$('input').on({
  focus: function () {
      $(this).data('placeholder', $(this).attr('placeholder'));
      $(this).attr('placeholder', '');
  },
  blur: function () {
      if ($(this).val() === '') {
          $(this).attr('placeholder', $(this).data('placeholder'));
      }
  }
});
function racetopprintMobole() {
  // $('.product-form1').css('width', '100%')

  $(".product__accordion").css("display", "none");
  if (!($(".product__titleh1").text() == "Transfer Sticker-Deals")) {
    $(".product__accordion").before($(".timegMobilepc2"));
  }

  $(".timegMobilepc2 i").css("background-position", "-681px -85px");

  $(".timegMobilepc2 span").css("float", "left");

  $(".timegMobilepc2").css("overflow", "hidden");

  $(".timegMobilepc2").css("font-size", "14px");



  $(".timegMobilepc2>div").css("border-bottom", "none");

  $(".timegMobilepc2").css("margin-top", "0");

  $(".timegMobile").parent().css("display", "none");

  $(".timegMobilepc2 span").css("margin-left", "6px");

  $(".isdiscountavailable").addClass(" afterz");
}

function Shape() {
  if ($(".limittheshape").val()) {
    $(".uploadShape").val($(".limittheshape").val());
  } else {
    $(".Shape div div").click(function () {
      $(".Shape .active").removeClass("active");

      $(this).addClass("active");

      $(".uploadShape").val(uploadShapeData[$(".Shape .active").index()]);
    });

    $(".uploadShape").val(uploadShapeData[$(".Shape .active").index()]);
  }
}

function materialxuanze() {
  $(".materialxuanzeMaterial1").click(function () {
    $(".materialxuanzeMaterial").toggle();
    if ($(".materialxuanzeMaterial").is(":visible")) {
      $(".materialxuanzeMaterial1").css("border-radius", "20px 20px 0 0");
      $(".materialxuanzeMaterial").css("border-radius", "0 0 20px 20px");
      $('.newproductselectSize').css('border-radius','15px')
    } else {
      $(".materialxuanzeMaterial1").css("border-radius", "20px");
      $('.newproductselectSize').css('border-radius','15px')
    }
  });
  $(".materialxuanze>div:first-child").addClass("active");
  $(".materialxuanze1 p:first-child").addClass("active");
  $(".materialxuanze2 p:first-child").addClass("active");
  $(".materialxuanze3 p:first-child").addClass("active");
  $(".materialInput").val($(".materialxuanze .active").text());
  $(".Finish").val($(".materialxuanze1 .active").text());
  $(".productTypeColor").val($(".materialxuanze2 .active").text());
  $(".newPrintType").val($(".materialxuanze3 .active").text());
  $(".materialxuanze>div").click(function () {
    $(".materialxuanze .active").removeClass("active");

    $(this).addClass("active");

    $(".materialInput").val($(".materialxuanze .active").text());
    $(".materialxuanzeMaterial1 p").text($(".materialxuanze .active").text());
    $(".materialxuanzeMaterial").css("display", "none");
    $(".materialxuanzeMaterial1").css("border-radius", "20px");
  });
  $(".materialxuanze1 p").click(function () {
    $(".materialxuanze1 .active").removeClass("active");

    $(this).addClass("active");
    $(".Finish").val($(".materialxuanze1 .active").text());
  });
  $(".materialxuanze2 p").click(function () {
    $(".materialxuanze2 .active").removeClass("active");

    $(this).addClass("active");

    $(".productTypeColor").val($(".materialxuanze2 .active").text());
  });
  $(".materialxuanze3 p").click(function () {
    $(".materialxuanze3 .active").removeClass("active");

    $(this).addClass("active");

    $(".newPrintType").val($(".materialxuanze3 .active").text());
  });

  $(".materialxuanzeformat>div:first-child").addClass("active");

  $(".format").val($(".materialxuanzeformat .active p").text());

  $(".materialxuanzeformat>div").click(function () {
    $(".materialxuanzeformat .active").removeClass("active");

    $(this).addClass("active");

    $(".format").val($(".materialxuanzeformat .active p").text());
  });
}

function jdgmrowprofile() {
  var profile = $(".jdgm-row-profile");

  profile.map((res) => {
    var st = "";

    $(profile[res])
      .find(".jdgm-rev__author")
      .text()
      .split(" ")
      .map((re) => {
        st += re[0];
      });
    var arr = st.split("");
    if (arr.length > 1) {
      st = arr[0] + arr[1];
    }
    var str =
      '<div class="jdgmrowprofileimg"><p>' +
      st +
      '</p><i class="backgroundImage"></i></div>';

    var rev__rating = $(profile[res]).parent().parent().parent().prepend(str);
  });
}

function editExtrastickersli() {
  var ele = $(".newproductselectdivQuantity .active");
  var ele1 = $(".newproductselectdivQuantity .active").next();
  ele1=ele1.attr('value')?ele1:ele1.next()
  if (
    $(ele1).text().indexOf("custom") < 0 &&
    $(ele).text().indexOf("custom") < 0
  ) {
    var price = currency(
      newCurrency($(ele1).find(".newproductselectdivQuantityp").text(), 1)
    ).subtract(
      newCurrency($(ele).find(".newproductselectdivQuantityp").text(), 1)
    );
    var sale = $(ele1).attr("value") - $(ele).attr("value");
    $(".Extrastickers span").text(newCurrency(price, 1));
    $(".Extrastickers p").text(sale);
    if (newCurrency(price, 1) < 0) {
      $(".Extrastickers").css("display", "none");
    }
    if ($(".Extrastickers p").text().indexOf("NaN") >= 0) {
      $(".Extrastickers").css("display", "none");
    }
  } else {
    $(".Extrastickers").css("display", "none");
  }
  $("#ContinueFunzId").css("display", "block");
  $(".ContinueFunzIdButton").css("display", "none");
}

var isContinueFunz = true;
function ContinueButton(UploadType, isHide) {
  if (isHide == 0) {
    //hide
    if (UploadType == 0) {
      //Normal upload
      $("#ContinueFunzId").css("display", "none");
      $(".ContinueFunzIdButton").css("display", "block");
    } else if (UploadType == 1) {
      //Tangent line
      $("#ContinueFunzId1").css("display", "none");
      $(".ContinueFunzId1Button").css("display", "block");
    } else if (UploadType == 2) {
      //cups-bag
      $("#ContinueFunzCupsId").css("display", "none");
      $(".ContinueFunzCupsButton").css("display", "block");
    }
  } else if (isHide == 1) {
    if (UploadType == 0) {
      //Normal upload
      $("#ContinueFunzId").css("display", "block");
      $(".ContinueFunzIdButton").css("display", "none");
    } else if (UploadType == 1) {
      //Tangent line
      $("#ContinueFunzId1").css("display", "block");
      $(".ContinueFunzId1Button").css("display", "none");
    } else if (UploadType == 2) {
      //cups-bag
      $("#ContinueFunzCupsId").css("display", "block");
      $(".ContinueFunzCupsButton").css("display", "none");
    }
  }
}
function ContinueFunzCupsIdHide() {
  $("#ContinueFunzCupsId").css("pointer-events", "none");
  $("#ContinueFunzCupsId").css("background", "#ddd");
}
function ContinueFunz() {
  var istrue = false;
  isContinueFunz = true;
  istrue = ContinueFunzBig(0);
  return istrue;
}
function ContinueFunzCups() {
  var istrue = false;
  isContinueFunz = true;
  istrue = ContinueFunzBig(2);
  return istrue;
}
// $('#ContinueFunzId1').click(function(){
//   $('.cartreloads').find('p').text('Create file...');
//   $('.cartreloads').css('display','block');
// })
function ContinueFunzBig(UploadType) {
  ContinueButton(UploadType, 0);
  var istrue = false;
  if (isdiy && isContinueFunz) {
    // if(!productVarId){
    productVarId = $(".uploadImgid").val();
    // }
    $(".uploadImgid").val(updateVariantInfoobj.code);
    isContinueFunz = false;
    function removeTrailingZeros(number) {
      return Number(String(number).replace(/0*$/, ""));
    }
    $(".Continue img").css("display", "block");
    if ($(".uploadProp3Textarea").val()) {
      $(".uploadImgidrema").val($(".uploadProp3Textarea").val());
    }
    var productId = $('input[name="product-id"]').val();
    var obj = {
      productId: productId,
      month: updateVariantInfoobj.month,
      quoteId: updateVariantInfoobj.quoteId,
      image: $(".designUpload").attr("src"),
      designId: productVarId,
    };
    $(".Continue").css("pointer-events", "none");
    var SinglePrice = 0;
    responsedatalist.map((res) => {
      var price = res.price / res.saleNum;
      if (SinglePrice) {
        if (responsedatalist < price) {
          responsedatalist = price;
        }
      } else {
        SinglePrice = newCurrency(price, 1);
      }
    });
    SinglePrice = newCurrency(SinglePrice, 1);
    var newlocaURLsaveProductQuoteData = [];
    responsedatalist.map((res) => {
      var obj = JSON.parse(JSON.stringify(quoteParamNew));
      obj.saleNum = res.saleNum;
      newlocaURLsaveProductQuoteData.push({
        templateProductId: productId,
        month: res.month,
        quoteId: res.id,
        quoteParam: obj,
        cartToken: orderObjList.token,
        diyProps: {},
        quoteCode: res.code,
      });
    });

    var newGetQuoteMetaField = $(".newGetQuoteMetaField");
    newGetQuoteMetaField.map((res) => {
      if ($(newGetQuoteMetaField[res]).attr("class").indexOf("active") >= 0) {
        var key = $(newGetQuoteMetaField[res]).attr("customerTypeName");
        var values = $(newGetQuoteMetaField[res]).attr("customerval");
        var meaning = $(newGetQuoteMetaField[res]).attr("meaning");
        if (meaning.indexOf("diyProp") >= 0) {
          newlocaURLsaveProductQuoteData.map((re) => {
            re.diyProps[meaning] = $(newGetQuoteMetaField[res]).text();
          });
        } else {
          newlocaURLsaveProductQuoteData.map((re) => {
            re[key] = values;
          });
        }
      }
    });
    var newnewlocaURLsaveProductQuoteData = {
      image: $(".designUpload").attr("src"),
      productId: productId,
      cartToken: orderObjList.token,
      checkedQuoteCode: updateVariantInfoobj.code,
      quoteDetails: [],
    };
    newlocaURLsaveProductQuoteData.map((re) => {
      newnewlocaURLsaveProductQuoteData.quoteDetails.push({
        month: re.month,
        quoteId: re.quoteId,
        quoteCode: re.quoteCode,
        quoteParam: re.quoteParam,
      });
    });
    $.ajax({
      url: newlocaURLsaveProductPlus,
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(newnewlocaURLsaveProductQuoteData),
      async: false,
      success: function (response) {
        if (response.result == "success") {
          // $.ajax({
          // 	url: newlocaURLsaveProduct,
          // 	type: 'POST',
          // 	contentType: 'application/json',
          // 	data: JSON.stringify(obj),
          //                    async:false,
          // 	success: function(response) {
          // 		if (response.result == 'success') {
          var obj = {
            OriginallyVariantId: response.data.variantId,
            "UploadDesign 1": $(".designUpload").attr("src"),
            manuscriptId: productVarId,
            note: {
              quoteId: updateVariantInfoobj.quoteId,
              month: updateVariantInfoobj.month,
              code: updateVariantInfoobj.code,
            },
            SinglePrice: SinglePrice,
            Originalquantity: newsize().saleNum,
            newCupsIdListFile: newCupsIdListFile.join(","),
            calendarTemplateId: "",
            paperCupId: paperCupId,
          };
          try {
            if (noteData) {
              noteData = noteData;
            } else {
              noteData = [];
            }
          } catch (error) {
            noteData = [];
          }
          var newnoteData = JSON.parse(JSON.stringify(noteData));
          newnoteData.push(obj);
          if (JSON.stringify(newnoteData).length > 5000) {
          } else {
            noteData.push(obj);
          }
          if(noteData[0]){
            noteData[0].cartToken=orderObjList.token
          }
          var variantId = response.data.variantId;
          $(".variantId").val(variantId);
          $(".uploadNote").val(JSON.stringify(noteData));
          newCupsIdListFileList.unshift($(".designUpload").attr("src"));
          let uniqueArr1 = [...new Set(newCupsIdListFileList)];
          newCupsIdListFileList = uniqueArr1;
          newCupsIdListFile.unshift(productVarId);
          let uniqueArr = [...new Set(newCupsIdListFile)];
          newCupsIdListFile = uniqueArr;
          var listId = [];
          newCupsIdListFile.map((res) => {
            if (res) {
              listId.push(+res);
            }
          });
          const uniqueArrList = Array.from(new Set(listId));
          newCupsIdListFile = uniqueArrList;
          //newnode
          var data = {
            variantId: variantId,
            designUrl: newCupsIdListFileList.join(","),
            designType: "manuscript",
            designId: newCupsIdListFile.join(","),
            singlePrice: SinglePrice,
            qty: 1,
            quoteMonth: updateVariantInfoobj.month,
            quoteId: updateVariantInfoobj.quoteId,
            quoteCode: updateVariantInfoobj.code,
            customerRemark: $(".uploadImgidrema").val(),
            productId: response.data.productId,
            size:
              isProductType == 1
                ? $(".newproductselectfirstchildSize").text()
                : newsize().width + " x " + newsize().height,
            saleNum: newsize().saleNum,
            title: $(".product__titleh1").text(),
            cartToken: orderObjList.token,
            userId: orderObjList.customerId,
            userName: orderObjList.customeremail,
            templateId: paperCupId,
            templateType: templateType,
            textInfo:JSON.stringify(textInfo)
            // deliveryDay:$('.deliveryDaysConfiguration').text()
          };
          $.ajax({
            url: newlocaURLevaluationNoteInfosave,
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            async: false,
            success: function (response) {
              $(".cartreloads").css("display", "none");
            },
          });
          //newnodeend
          // 产品加购数据统计
          try {
            var obj = [
              {
                productId: productId,
                variantId: variantId,
                size: $(".newproductselectfirstchildSize").text(),
                qty: newsize().saleNum,
                title: $(".product__titleh1").text(),
                operationType: "add_to_cart",
                fromUrl: document.referrer,
                clidCreateTime: getCookies().clidCreateTime,
                clid: getCookies().clid,
                customerId: $(".customerId").text()
                  ? $(".customerId").text()
                  : "",
              },
            ];
            $.ajax({
              url: newlocaURLaddPurchaseRecord,
              type: "POST",
              contentType: "application/json",
              data: JSON.stringify(obj),
              success: function (respo) {
                $(".cartreloads").css("display", "none");
              },
            });
            // 数据统计
            gsf_google_analytics_add_to_cart_event_dataFun([{
              product_id:productId,
              title:$(".product__titleh1").text(),
              item_category:$('.productTypeItem_category').text(),
              variant_id:variantId,
              variant_title:$(".newproductselectfirstchildSize").text()+'/'+newsize().saleNum,
              price:$('.newpricez').text().replace('$',''),
              quantity:1,
              vendor:$('.productVendor').text()
            }])
          } catch (e) {
            console.log('error', e.message);
          }
          istrue = true;
          $(".cartreloads").css("display", "none");
          // } else {
          //                          isContinueFunz=true
          //                          ContinueButton(UploadType,1)
          // 	tipShow(response.message)
          //                        $('.cartreloads').css('display','none');
          // }
          // 	},
          // 	error: function(xhr, status, error) {
          //                      $('.cartreloads').css('display','none');
          //                    }
          // });
        } else {
          ContinueButton(UploadType, 1);
          isContinueFunz = true;
          $(".cartreloads").css("display", "none");
        }
      },
    });
  }
  $(".cartreloads").css("display", "none");
  return istrue;
}
$(".ContinueFunzIdButtonwhether").click(function () {
  tipShow("Note: This promotional desk calendar is limited to one per order.");
});
productNewDetailLoadTime = +new Date();
fetch("/cart.js")
  .then((response) => response.json())
  .then((cartData) => {
    if (cartData.items.length || cartData.token.length != 32) {
      orderObjList.token = cartData.token.split("?")[0];
    } else {
      var requestData = {
        items: [
          {
            quantity: 1,
            id: stickergiftsVariant_id,
          },
        ],
      };
      fetch("/cart/add.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
        credentials: "same-origin",
      })
        .then((response) => response.json())
        .then((data) => {
          var data = {
            line: 0,
            quantity: 0,
          };
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              orderObjList.token = data.token.split("?")[0];
            });
        });
    }
    var note = cartData.note ? JSON.parse(cartData.note) : [];
    var items = cartData.items;
    var arr = [];
    if (typeof note == "string") {
      note = JSON.parse(note);
    }
    if (note.noteId) {
    } else {
      note.map((res) => {
        items.map((re) => {
          if (re.properties.id) {
            if (
              re.properties.id == res.manuscriptId ||
              re.properties.id == res.diyId ||
              re.properties.id == res.note.code
            ) {
              arr.push(res);
            }
          } else {
            if (re.variant_id == res.OriginallyVariantId) {
              arr.push(res);
            }
          }
        });
      });
    }
    arr.map((re) => {
      var num = 0;
      noteData.map((res) => {
        if (re.manuscriptId == res.manuscriptId) {
          num++;
        }
      });
      if (num == 0) {
        noteData.push(re);
      }
    });
  });

$("body").on(
  "click",
  " #cart-notification .product-option dd>a",
  function (event) {
    event.preventDefault();

    $(".imgfangda").css("display", "block");

    $(".imgfangdaimg").attr(
      "src",
      $(this).attr("href").split("!0X")[0] + "!0X900"
    );
  }
);

$(".imgfangda").click(function () {
  $(this).css("display", "none");
});

textwen = true;

materialxuanze();

Shape();

if (window.document.body.clientWidth < 750) {
  // $('#main-prod-coupon').prependTo($('#main-prod-coupon').parent());
  product__titleh1();
} else {
  racetopprintMobole();
}

$("#copyBtn").click(function () {
  copyBtn();

  tipShow("Discount code copied successfully");
});


$(".no-js-hidden").css("pointer-events", "initial");

edittitle();

productPingxingshuju();

$(".newAddCart").click(function () {
  if (isdiy) {
    $(".addCartTishi").css("display", "block");

    $(".addwithTishi").css("display", "none");

    $(".addCartTishiz").css("display", "block");

    $(".uploadImgInput").val("");

    $(".uploadImgid").val("");

    $(".uploadImgidrema").val("");
  } else {
    tipShow("Please enter custom size and quantity");
  }
});
$(".addCartTishicancel").click(function () {
  $(".addCartTishi").css("display", "none");
});

$(".addwithTishicancel").click(function () {
  $(".addCartTishi").css("display", "none");
});

$(".newBuy").click(function () {
  $(".addCartTishi").css("display", "block");

  $(".addwithTishi").css("display", "block");

  $(".addCartTishiz").css("display", "none");
});

$(".addCartTishiconfirm").click(function () {
  $(".product-form__buttons1 .button--secondary").click();

  setTimeout((res) => {
    $(".addCartTishi").css("display", "none");
  }, 500);
});

$(".addwithTishiconfirm").click(function () {
  var url =
    locaTranslateUrl +
    $("input[name='id']").val() +
    ":" +
    $(".quantityvalue").val() +
    "?channel=buy_button";

  var checkoutUrl = "/checkout?cart=";

  if (isIOS()) {
    window.location.href = checkoutUrl;
  } else {
    window.open(checkoutUrl);
  }

  setTimeout((res) => {
    $(".addCartTishi").css("display", "none");
  }, 500);
});

// $("a").click(function() {

// 	$("html, body").animate({

// 		scrollTop: $($(this).attr("href")).offset().top + "px"

// 	}, 1000);

// 	return false;

// });

$(".productPingxingshujuReviews").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#productPingxingshuju").offset().top - 150,
    },
    1000
  );

  $(".overviewall .ac").removeClass("ac");

  $(".productPingxingshujuReviews").addClass("ac");

  return false;
});

window.addEventListener("DOMContentLoaded", function () {
  loadEdit();
  $(".uploadProp3Textarea").change(function () {
    $(".uploadProp3Textarea").val($(this).val());
    $(".uploadImgidrema").val($(this).val());
    $(".uploadProp3TextareadiyTextarea").val($(this).val());
    $(".uploadProp3Textareadiy").val($(this).val());
  });
  $(".uploadProp3Textareadiy").change(function () {
    $(".uploadProp3Textarea").val($(this).val());
    $(".uploadProp3Textareadiy").val($(this).val());
    $(".uploadImgidrema").val($(this).val());
    $(".uploadProp3TextareadiyTextarea").val($(this).val());
  });
  $(".uploadProp3TextareadiyTextarea").change(function () {
    $(".uploadProp3Textarea").val($(this).val());
    $(".uploadImgidrema").val($(this).val());
    $(".uploadProp3TextareadiyTextarea").val($(this).val());
    $(".uploadProp3Textareadiy").val($(this).val());
  });
  $(".InstructionsTip1 svg").click(function () {
    $(".InstructionsTip1").css("display", "none");
  });
  $(".InstructionsTip button:first-child").click(function () {
    $(".InstructionsTip").css("display", "none");
    $(".uploadProp").css("display", "none");
    $(".uploadPropTipDiy").css("display", "none");
    $(".uploadPropTipDiyz .uploadPropTipDiyDivLeft").css('display','block');
    $(".product-submite-tip,.product-submite-tip .single-side-tip").css('display','none');
    $("#ContinueFunzId1").prop("disabled", true);
    isaddcart = false;
    $(".canvas-container-init").css("display", "flex");
    canvasSource = null;
     cutShapeTipFlag = true;
     startDieCutFlag = false;
    $('.cut-shape-m-tooltip-content').css('display', 'none');
    $(".remove-background,.become-clearer").addClass("on");
    $('.stickers-cut-line-button-group').addClass('disabled');
      $('.stickers-cut-line-button-area').removeClass('stickers-cut-line-active').eq(1).addClass('stickers-cut-line-active');
    if (isShowisInstructionsTipFun) {
      isInstructionsTipFun();
    }
  });
  $(".InstructionsTip button:last-child").click(function () {
    $(".InstructionsTip").css("display", "none");
    $(".uploadProp3Textareadiy").focus();
    $(".uploadProp3Textareadiy").css("border", "1px solid #333");
  });
  $(".InstructionsTip1 button:last-child").click(function () {
    $(".InstructionsTip1").css("display", "none");
    $(".uploadProp3Textareadiy").focus();
    $(".uploadProp3Textareadiy").css("border", "1px solid #333");
  });

  var swiper = new Swiper(".mySwiperMobile1z", {
    pagination: {
      el: ".swiper-pagination2",
    },

    autoplay: {
      delay: 2500,

      disableOnInteraction: false,
    },
  });
  var swiper = new Swiper(".racetopprintMobolenewbanner", {
    slidesPerView: 1,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });
  if (window.document.body.clientWidth < 750) {
    EvaluationcontentSwiper(".myProductSwiper", 3);
    EvaluationcontentSwiper(".EvaluationcontentSwiper", 3);

    $(".Evaluationcontentp").click(function () {
      $("body,html").animate(
        {
          scrollTop: $("#productPingxingshuju").offset().top - 130,
        },
        500
      );

      $(".overviewall .ac").removeClass("ac");

      $(".productPingxingshujuReviews").addClass("ac");
    });
  } else {
    EvaluationcontentSwiper(".myProductSwiper", 5);

    EvaluationcontentSwiper(".EvaluationcontentSwiper", 5);

    var lastScrollTop = 0;
    var overviewall = "";

    $(".overviewall a").click(function () {
      $(".overviewall .ac").removeClass("ac");

      $(this).addClass("ac");

      overviewall = $(this).attr("href").substring(1);
    });

    $(".Evaluationcontentp").click(function () {
      $("body,html").animate(
        {
          scrollTop: $("#productPingxingshuju").offset().top - 260,
        },
        500
      );
    });
  }
});

document.querySelectorAll('input[name="Size"]').forEach(function (radio) {
  radio.addEventListener("change", function () {
    var selectedSize = this.value;

    $($(".selectz")[0]).val(selectedSize).trigger("change");
  });
});

if ($(".fraction1").attr("src")) {
  $(".fraction img").attr("src", $(".fraction1").attr("src"));

  $(".fraction p").text($(".fraction2").text());
}

var customGtagUploadEvent = function () {
  if (!window.gtag) return;
  window.gtag("event", "button_click", {
    event_category: "interaction",
    event_label: "upload_button",
    value: 1,
  });
};

var hasProdVariantInOrder = function (productId = "") {
  return new Promise((resolve, reject) => {
    var data = {
      email: $(".emOrder").text(),
      productId: productId,
    };
    $.ajax({
      url: newlocaURLevaluationgetbuyRecord,
      type: "post",
      contentType: "application/json",
      data: JSON.stringify(data),
      success: (res) => {
        if (res.code == 200) {
          resolve(true);
        } else {
          resolve(false);
        }
      },
    });
  });
};
var hasProdVariantInCart = function (productIDs = []) {
  return new Promise((resolve) => {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cartData) => {
        var has = cartData.items.find(
          (item) => productIDs.indexOf(item.product_id + "") !== -1
        );
        resolve(!!has);
      });
  });
};
var checkMultipleProdVariantsInOrder = function (
  productIds = [],
  isOne = true
) {
  var res = [];
  return new Promise((resolve) => {
    for (var i = 0; i < productIds.length; i++) {
      (function (index) {
        hasProdVariantInOrder(productIds[index])
          .then((value) => {
            res[index] = value;
            if (!value) {
              resolve(false);
              return;
            }
            if (res.length === productIds.length) {
              resolve(isOne ? res.some((i) => i) : res.every((i) => i));
            }
          })
          .catch((reason) => {
            res[index] = false;
            if (res.length === productIds.length) {
              resolve(isOne ? res.some((i) => i) : res.every((i) => i));
            }
          });
      })(i);
    }
  });
};
var PRODUCT_CHECKOU_RES_MAP = {
  canAddToCart: "can add to cart",
  purchased: "purchased",
  unFindProd: "can not find product id",
  unLogined: "un logined",
  otherProd: "other product",
};
var someProdVariantUploadToSignin = function () {
  return new Promise((resolve, reject) => {
    var fixedProdVariant = ["8857333235964", "8857333137660"];
    var prodIdElement = document.querySelector("div[class *= product-id-]");
    if (!prodIdElement) {
      resolve(PRODUCT_CHECKOU_RES_MAP.otherProd);
      return;
    }
    var prodIdMatchRes = prodIdElement.className.match(/product-id-(\d+)/);
    var prodId = prodIdMatchRes[1] || "";
    if (fixedProdVariant.indexOf(prodId + "") !== -1) {
      if (window.loginStatus) {
        // 已登录
        Promise.all([
          hasProdVariantInCart([prodId]),
          checkMultipleProdVariantsInOrder([prodId]),
        ])
          .then((res) => {
            if (!res[0] && res[1]) {
              resolve(PRODUCT_CHECKOU_RES_MAP.canAddToCart);
            } else {
              resolve(PRODUCT_CHECKOU_RES_MAP.purchased);
            }
          })
          .catch(() => {
            resolve(PRODUCT_CHECKOU_RES_MAP.purchased);
          });
      } else {
        // 未登录
        resolve(PRODUCT_CHECKOU_RES_MAP.unLogined);
      }
    } else {
      resolve(PRODUCT_CHECKOU_RES_MAP.otherProd);
    }
  });
};

$(".uploadDesign").click(function () {
  if(window.innerWidth<750){
    $('.product-formAddToCart').appendTo('.uploadFileImg');
    $('.product-formAddToCart').insertAfter('.uploadFileDiy');
  }
  customGtagUploadEvent();
  var fn = function () {
    isInstructionsTip = true;
    if (isdiy) {
      let initFlagChxy = false;
      if (
        UploadProductType.UploadProductType &&
        UploadProductType.UploadProductType.name &&
        UploadProductType.UploadProductType.name != ""
      ) {
        //Products that require access to the designer
        let productTypeArr = [
          "cup",
          "handbag",
          "Tabletop Display",
          "vinylbanner",
          "Retractable Banners",
          "Posters",
          "heldBag",
          "toteBag",
          "flatBag",
          "ribbonBag",
          "Planner",
        ];

        //let productTypeArr=["cup","handbag","Tabletop Display","vinylbanner","Retractable Banners","Posters"];
        for (let item of productTypeArr) {
          if (UploadProductType.UploadProductType.name.indexOf(item) > -1) {
            if (
              item == "Posters" &&
              window.innerWidth > 750 &&
              window.innerWidth < 1500
            ) {
              $("#uploadPropTipDiyDivLeft").css("padding-bottom", 0);
            }
            initFlagChxy = true;
          }
        }
      }
      if ($("._startuploaddiy").text() == 1) {
        initFlagChxy = true;
      }
      if (initFlagChxy) {
        if ($("._diyNewVersion").text() == 1) {
          const isPc = window.innerWidth > 1024;
          const guideNum = (JSON.parse(localStorage.getItem('new-canvas-diy')) || {}).guideNum || 0;
          if(isPc){//PC
            $("#diy-content-m").remove();
            $("#new-canvas-Diy").css("display", "flex");
            guideNum < 2 && $("#new-canvas-Diy .dialog-guide").css("display", "block");
          }else{
            $("#diy-content").remove();
            $("#new-canvas-Diy").addClass("diy-m-show");
            guideNum < 2 && $("#new-canvas-Diy .dialog-guide").addClass("guide-m-show");
          }
          setTimeout(showNewDiy)
        }else{
          $(".paper-handbag-Diy").css("display", "block");
          initSizeCanvas();
          $(".uploadProp3Textareadiy").val($(".uploadProp3Textarea").val());
          $(".uploadPropInputDiy").val("");
          // $('.uploadProp').css('display','none')
          $(".uploadPropTipDiy").css("display", "none");
          ContinueFunzCupsIdHide();
        }
      } else {
        $(".preview").css("display", "none");
        // $('.uploadProp').css('display','block')
        $(".uploadPropTipDiy").css("display", "block");
        if($('.stickersLabels').text().indexOf("stickers")>-1 && UploadProductType.UploadProductType.name=="sticker$coasters"){
          $('.uploadPropTipDiy .img-btn-boxbuButton').remove();
          $(".stickers-cut-line-button-group").remove();
          $(".shape-selection-box .dieCut").css("display","none");//杯垫 采用不干胶去除异型
        }
        if($('.stickersLabels').text().indexOf("stickers")>-1 && (UploadProductType.UploadProductType.name=="labels$keychains" || UploadProductType.UploadProductType.name=="labels$acrylicStand" || UploadProductType.UploadProductType.name=="labels$fridgeMagnets") ){
          $('.uploadPropTipDiy .img-btn-boxbuButton').remove();
          $(".stickers-cut-line-button-group").remove();
          // 钥匙扣 立牌 冰箱贴 只显示异形模切
          $('.shape-selection-box > div').hide();
          $('.shape-selection-box > div').has('button[line-type="diecut"]').show();
        }
        stickersLabelsType = {
          name: stickersLabels.split("-")[0],
          type: stickersLabels.split("-")[1],
        };
        var index = 0;
        if (stickersLabelsType.type == "square") {
          index = 0;
        } else if (stickersLabelsType.type == "rounded") {
          index = 1;
        } else if (stickersLabelsType.type == "circle") {
          index = 2;
        } else {
          index = 3;
        }
        $(".shape-selection-box .active").removeClass("active");
        $($(".shape-selection-box>div")[index]).addClass("active");
        $(".uploadPropInput").val("");

        $(".uploadProp3Textarea").val("");

        $(".uploadProp1 span").text("");

        $(".designUpload").attr("src", "");

        $(".container").css("display", "none");
        $(".Continue img").css("display", "none");
        $(".Continue").css("background", "#ddd");
        $(".Continue").css("pointer-events", "none");
        $("#ContinueFunzId").css("pointer-events", "none");
        $("#ContinueFunzId").css("background", "#ddd");
      }
    } else {
      tipShow(tipText());
    }
  };
  someProdVariantUploadToSignin().then((res) => {
    if (res) {
      if (
        [
          PRODUCT_CHECKOU_RES_MAP.canAddToCart,
          PRODUCT_CHECKOU_RES_MAP.otherProd,
          PRODUCT_CHECKOU_RES_MAP.unFindProd,
        ].some((k) => k === res)
      ) {
        fn();
      } else if (res === PRODUCT_CHECKOU_RES_MAP.unLogined) {
        // 未登录
        // document.querySelector('.header__icon--account').click();
        $(".header__icon--account").click();
      } else if (res === PRODUCT_CHECKOU_RES_MAP.purchased) {
        // 已购买
        window && window.spToast();
      }
    } else {
      fn();
    }
  });
});
$(".uploadPropTipDiy .close-design").click(function () {
  if (!isInstructionsTip) {
    $(".InstructionsTip").css("display", "block");
    isInstructionsTip = true;
  } else {
    // destroy canvas
    if ($(".new-start-draw-diecut").length > 0) {
      $(".canvas-container").remove();
      $(".uploadProp3Textareadiy").val("");
      $(".uploadPropInputDiy").val("");
      $(".new-start-draw-diecut").removeClass("new-start-draw-diecut-active");
      $('.stickers-cut-line-button-group').addClass('disabled');
      $('.stickers-cut-line-button-area').removeClass('stickers-cut-line-active').eq(1).addClass('stickers-cut-line-active');
    }
    $(".uploadPropTipDiy").css("display", "none");
    $(".uploadPropTipDiyz .uploadPropTipDiyDivLeft").css('display','block');
    $(".product-submite-tip,.product-submite-tip .single-side-tip").css('display','none');
    $("#ContinueFunzId1").prop("disabled", true);
    isaddcart = false;
    $(".canvas-container-init").css("display", "flex");
    canvasSource = null;
    cutShapeTipFlag = true;
    startDieCutFlag = false;
    $('.cut-shape-m-tooltip-content').css('display', 'none');
    $(".remove-background,.become-clearer").addClass("on");
    $(".stickers-cut-line-button-group").addClass("disabled");
  }
});
$(".uploadProp .coloe").click(function () {
  $(".uploadProp").css("display", "none");
});

$(".uploadProp2 span").click(function () {
  $(".uploadProp2 .active").removeClass("active");

  $(this).addClass("active");

  $(".uploadProp3 .active").removeClass("active");

  $($(".uploadProp3>div")[$(this).index()]).addClass("active");
});

var customGtagDesignEvent = function () {
  if (!window.gtag) return;
  window.gtag("event", "button_click", {
    event_category: "interaction",
    event_label: "design_button",
    value: 1,
  });
  gtag_report_conversion_design();
};

$(".diy").click(function (e) {
  customGtagDesignEvent();

  var fn = function () {
    $(document).trigger(
      $.Event("keyup", {
        keyCode: 27,
      })
    );

    if (isdiy) {
      function getCookie(name) {
        var value = "; " + document.cookie;

        var parts = value.split("; " + name + "=");

        if (parts.length == 2) return parts.pop().split(";").shift();
      }

      var token = orderObjList.token;

      var variant_id = $("input[name='id']").val();

      var customerid = $(".customerid").text();

      var product_name = $(".product__titleh1").text();

      var uid = $(".customerId").text();

      var priceitem = $(".price-item--last.price-item--sale").text();

      var xinghao = $(".selecta1 select");

      var st = "";

      xinghao.map((res) => {
        st +=
          $($(xinghao)[res]).parent().prev().prev().text().replace(/\s/g, "") +
          ":" +
          $($(xinghao)[res]).val().replace(/\s/g, "") +
          ",";
      });

      var quantityvalue = newsize().quantityvalue;

      var sizewidth = newsize().sizewidth;

      var width = newsize().width.replace(/\s/g, "");

      var height = newsize().height.replace(/\s/g, "");

      var saleNum = newsize().saleNum.replace(/\s/g, "");

      var size = width + "x" + height;

      size = size.replace(/\s/g, "");

      var tmpType = $(".tmpType").text();

      var str = $(".isAlien").text() == "是" ? "&clear=1" : "";

      function removeTrailingZeros(number) {
        return Number(String(number).replace(/0*$/, ""));
      }
      var sizeData =
        removeTrailingZeros(newsize().width.replace(/\s/g, "")) +
        '"x' +
        removeTrailingZeros(newsize().height.replace(/\s/g, "")) +
        '"';
      var newproductselectdivSizeList = $(".newproductselectdivSize>div");
      var newproductselectdivSizeValue = false;
      newproductselectdivSizeList.map((res) => {
        if (
          $(newproductselectdivSizeList[res])
            .children("p")
            .text()
            .replace(/\s/g, "") == sizeData
        ) {
          newproductselectdivSizeValue = true;
        }
      });
      var newproductselectdivQuantitylist = $(
        ".newproductselectdivQuantity>div"
      );
      var newproductselectdivQuantityValue = false;
      newproductselectdivQuantitylist.map((res) => {
        var str = $(newproductselectdivQuantitylist[res])
          .children("p")
          .text()
          .replace(/\s/g, "");
        if (str == newsize().saleNum.replace(/\s/g, "")) {
          newproductselectdivQuantityValue = true;
        }
      });
      var iscreateProduct =
        newproductselectdivSizeValue && newproductselectdivQuantityValue
          ? 1
          : 2;
      var format = newsize().format ? newsize().format : "1";
      var Shape = $(".uploadShape").val();
      var price = $(".newpricez").text();
      var productId = $('input[name="product-id"]').val();
      var SinglePrice = 0;
      responsedatalist.map((res) => {
        var price = res.price / res.saleNum;
        if (SinglePrice) {
          if (responsedatalist < price) {
            responsedatalist = price;
          }
        } else {
          SinglePrice = price;
        }
      });
      var obj = {
        productId: productId,
        month: updateVariantInfoobj.month,
        quoteId: updateVariantInfoobj.quoteId,
        code: updateVariantInfoobj.code,
      };
      var newGetQuoteMetaFieldO = {};
      var newGetQuoteMetaField = $(".newGetQuoteMetaField");
      newGetQuoteMetaField.map((res) => {
        if ($(newGetQuoteMetaField[res]).attr("class").indexOf("active") >= 0) {
          var key = $(newGetQuoteMetaField[res]).attr("customerTypeName");
          var values = $(newGetQuoteMetaField[res]).attr("customerval");
          newGetQuoteMetaFieldO[key] = values;
        }
      });
      var newlocaURLsaveProductQuoteData = [];
      responsedatalist.map((res) => {
        var obj = JSON.parse(JSON.stringify(quoteParamNew));
        obj.saleNum = res.saleNum;
        newlocaURLsaveProductQuoteData.push({
          templateProductId: productId,
          month: res.month,
          quoteId: res.id,
          quoteParam: obj,
          cartToken: orderObjList.token,
          diyProps: {},
          quoteCode: res.code,
        });
      });

      var newGetQuoteMetaField = $(".newGetQuoteMetaField");
      newGetQuoteMetaField.map((res) => {
        if ($(newGetQuoteMetaField[res]).attr("class").indexOf("active") >= 0) {
          var key = $(newGetQuoteMetaField[res]).attr("customerTypeName");
          var values = $(newGetQuoteMetaField[res]).attr("customerval");
          var meaning = $(newGetQuoteMetaField[res]).attr("meaning");
          if (meaning.indexOf("diyProp") >= 0) {
            newlocaURLsaveProductQuoteData.map((re) => {
              re.diyProps[meaning] = $(newGetQuoteMetaField[res]).text();
            });
          } else {
            newlocaURLsaveProductQuoteData.map((re) => {
              re[key] = values;
            });
          }
        }
      });
      localStorage.setItem(
        "newlocaURLsaveProductQuoteData",
        JSON.stringify(newlocaURLsaveProductQuoteData)
      );
      var siteOrigin = "";
      if (monetaryUnit.ismultistation) {
        siteOrigin = windowCountryName;
      }
      $.ajax({
        url: newlocaURLsaveProduct,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(obj),
        success: function (response) {
          var isHasShape = $(".isHasShape").text();
          var url =
            locaURLDesign +
            "/pages/design-1?variant_id=" +
            response.data.variantId +
            "&siteOrigin=" +
            siteOrigin +
            "&product_name=" +
            product_name +
            "&priceitem=" +
            priceitem +
            "&guigexinghao=" +
            st +
            "&product_form_idz=" +
            $(".product_form_idz").text() +
            "&token=" +
            token +
            "&quantityvalue=" +
            quantityvalue +
            "&size=" +
            size +
            "&saleNum=" +
            saleNum +
            "&tmpType=" +
            tmpType +
            "&uid=" +
            uid +
            str +
            "&material=" +
            newsize().materialInput +
            "&Finish=" +
            newsize().Finish +
            "&formattype=" +
            newsize().format +
            "&productTypeColor=" +
            newsize().productTypeColor +
            "&iscreateProduct=" +
            iscreateProduct +
            "&updateVariantInfoobj=" +
            JSON.stringify(updateVariantInfoobj) +
            (isHasShape ? "" : "&Shape=" + Shape) +
            "&price=" +
            price +
            "&productId=" +
            productId +
            "&SinglePrice=" +
            SinglePrice +
            "&Originalquantity=" +
            newsize().saleNum +
            "&customeremail=" +
            orderObjList.customeremail +
            "&newGetQuoteMetaFieldO=" +
            JSON.stringify(newGetQuoteMetaFieldO);
          if (width && height && saleNum) {
            if (isIOS()) {
              window.location.href = url;
            } else {
              window.open(url);
            }
          } else {
            tipShow(tipText());
          }
        },
      });
    } else {
      tipShow(tipText());
    }
  };
  someProdVariantUploadToSignin().then((res) => {
    if (res) {
      if (
        [
          PRODUCT_CHECKOU_RES_MAP.canAddToCart,
          PRODUCT_CHECKOU_RES_MAP.otherProd,
          PRODUCT_CHECKOU_RES_MAP.unFindProd,
        ].some((k) => k === res)
      ) {
        fn();
      } else if (res === PRODUCT_CHECKOU_RES_MAP.unLogined) {
        // 未登录
        // document.querySelector('.header__icon--account').click();
        $(".header__icon--account").click();
      } else if (res === PRODUCT_CHECKOU_RES_MAP.purchased) {
        // 已购买
        // tipShow(
        //   "The promotion item is already in your cart. Limit of one per customer. Thanks for understanding!"
        // );
        window && window.spToast();
      }
    } else {
      fn();
    }
  });
});
$(".uploadPropInput").change(function () {
  if (isdiy) {
    var formData = new FormData();

    if (!$(".uploadPropInput")[0].files.length) {
      tipShow("Please select a file");

      return;
    }
    var name = $(".uploadPropInput")[0].files[0].name;

    formData.append("file", $(".uploadPropInput")[0].files[0]);

    formData.append("goodsname", $(".product__titleh1").text());

    if ($(".uploadProp3Textarea").val()) {
      formData.append("remark", $(".uploadProp3Textarea").val());
    }

    $(".container").css("display", "block");

    isaddcart = false;
    $.ajax({
      url: locaUploadzlg,

      type: "post",

      data: formData,

      processData: false,

      contentType: false,

      dataType: "json",

      success: (res) => {
        $(".container").css("display", "none");

        if (res.result == "true") {
          productVarId = res.id;
          $("#ContinueFunzId").css("pointer-events", "initial");
          $("#ContinueFunzId").css("background", backgroundColor);
          if (isProductType == 1) {
          } else if (
            $(".product__titleh1").text().indexOf("Stickers") >= 0 ||
            $(".product__titleh1").text().indexOf("Labels") >= 0 ||
            $(".product__titleh1").text().indexOf("Decal") >= 0 ||
            $(".product__titleh1").text().indexOf("Iron-On") >= 0 ||
            $(".product__titleh1").text().indexOf("static") >= 0
          ) {
            var nameList = name
              .split(".")
              [name.split(".").length - 1].toLowerCase();
            if (
              nameList.indexOf("jpeg") >= 0 ||
              nameList.indexOf("png") >= 0 ||
              nameList.indexOf("jpg") >= 0 ||
              nameList.indexOf("heic") >= 0 ||
              nameList.indexOf("webp") >= 0
            ) {
              let inchWidth = newsize().width;
              let inchHeight = newsize().height;
              let drawImageUrl = res.path;
              let imgFactWidth = res.widthpx;
              let imgFactHeight = res.hightpx;
              let uniqueId = res.id;
              // square-right  square-circle  circle
              var text = "";
              if ($(".Shape>div>div").length) {
                text = $(".uploadShape").val();
              }
              if ($(".product__titleh1").text().indexOf("Labels") >= 0) {
                $(".dieCut").css("display", "none");
              }
              if (
                /*$('.uploadShape').val()&&$('.uploadShape').val()=='Die cut'||*/ $(
                  ".product__titleh1"
                )
                  .text()
                  .indexOf("Die Cut") >= 0
              ) {
                $(".uploadPropTipDiy>div>p").css("display", "none");
                $(".ShapeselectionDiy").css("display", "none");
                btnShowOrHide(false);
                reloadImgObjs.nocropImg = drawImageUrl;
                reloadImgObjs.noclearImg = drawImageUrl;
                getExtractDieCutData(
                  inchWidth,
                  inchHeight,
                  drawImageUrl,
                  imgFactWidth,
                  imgFactHeight,
                  uniqueId,
                  text,
                  UploadProductType.UploadProductType.name
                );
              } else {
                $(".ShapeselectionDiy").css("display", "block");
                initCanvas(
                  inchWidth,
                  inchHeight,
                  drawImageUrl,
                  imgFactWidth,
                  imgFactHeight,
                  uniqueId,
                  text,
                  UploadProductType.UploadProductType.name
                );
                $(".designUpload").attr("src", res.path);
              }
              $(".uploadPropTipDiy").css("display", "block");
              $(".uploadProp3Textareadiy").val($(".uploadProp3Textarea").val());
              $(".uploadPropInputDiy").val("");
              $(".uploadProp").css("display", "none");
            }
          }
          isaddcart = true;
          $(".Continue").css("background", backgroundColor);
          $(".Continue").css("pointer-events", "initial");
          $(".designUpload").attr("src", res.path);

          $(".designUploadclose").css("display", "block");

          $(".uploadProp1 span").text(res.path);

          $(".uploadImgInput").val(res.path);

          $(".uploadImgid").val(res.id);
          if ($(".uploadProp3Textarea").val()) {
            $(".uploadImgidrema").val($(".uploadProp3Textarea").val());
          }
        }

        tipShow(res.message);
      },
    });

    $(".designUploadcloseimg").click(function () {
      $(".designUploadclose").css("display", "none");

      $(".designUpload").attr("src", "");

      $(".uploadImgInput").val("");

      $(".uploadImgid").val("");
    });
  } else {
    tipShow("Failed to obtain quotation, refresh and retry");
  }
});

// $('.ShapeselectionDiy>div>div').click(function(){
//   $('.ShapeselectionDiy>div .active').removeClass('active')
//   $(this).addClass('active')
// })

//custom
function judge(that, text, text1) {
  function removeTrailingZeros(number) {
    number = +number;
    var result = number.toFixed(2);
    return result.replace(/\.00$/, "").replace(/\.0$/, "");
  }
  $(that).val(removeTrailingZeros($(that).val()));

  if (+$(that).val() > +$(that).attr("max")) {
    $(that).val($(that).attr("max"));

    tipShow(text + $(that).attr("max"));
  } else if (+$(that).val() < +$(that).attr("min")) {
    $(that).val($(that).attr("min"));

    tipShow(text1 + $(that).attr("min"));
  }
}
$(".sizeheight").click(function(e){
  e.stopPropagation();
})
$(".sizewidth").click(function(e){
  e.stopPropagation();
})
$(".sizeheight").change(function (e) {
  e.stopPropagation();
  judge(
    this,
    "The size height cannot exceed ",
    "The size height cannot be less than "
  );
  if ($(".sizewidth").val() > 0) {
    editWidthHeight();
    setTimeout((re) => {
      $('.customSize').click()
    }, 300);
  }
});

$(".sizewidth").change(function (e) {
  e.stopPropagation();
  judge(
    this,
    "The size width cannot exceed ",
    "The size width cannot be less than "
  );
  if ($(".sizeheight").attr("disabled")) {
    $(".sizeheight").val($(".sizewidth").val());
  }
  if ($(".sizeheight").val() > 0) {
    editWidthHeight();
    setTimeout((re) => {
      $('.customSize').click()
    }, 300);
  }
});
function editWidthHeight() {
  $(".newproductselectfirstchildSize").text(
    newsize().width + '"x ' + newsize().height + '"'
  );
}

$(".customQuantitysale").change(function () {
  judge(
    this,
    "The quantity of products cannot exceed ",
    "The quantity of products cannot be less than "
  );
  // $('.customQuantitysale').val(parseInt($('.customQuantitysale').val()))
  if ($(".customQuantitysale").val() > 0) {
    setTimeout((re) => {
      cust();
    }, 300);
  }
});
var ischangez = true;
// jdgmrowprofile();
function restorativeState(){
  if ($(".newproductselectdivSize").is(":visible")) {
    if (newsize().width > 0 && newsize().height > 0) {
    } else {
      $(".newproductselectdivSize>div:first-child").click();
    }
    $(".newproductselectdivSize").css("display", "none");
    $(".newproductselectfirstchild").css("border-radius", "15px");
  }
  if ($(".materialxuanzeMaterial").is(":visible")) {
    $(".materialxuanzeMaterial").css("display", "none");
    $(".forma2Select").css("border-radius", "15px");
  }
  $(".newproductselectSize").css("border-radius", "15px");
  $('.format2Finish').css('border-radius','15px')
  $('.materialxuanze1').css('display','none')
}
$("body").click(function () {
  // if(document.body.clientWidth < 750){
  //   $('.newproductselectdivQuantity').css('display','none')
  // }
  restorativeState()
});
$(".helpvideo").click(function () {
  $(".helpvideo").html(
    "<video style='width:100%;height:100%;' controls muted><source src='https://cdn.shopify.com/videos/c/o/v/e6ceceaf645b40139ef9ad92e3a5519b.mp4' type='video/mp4'>Your browser does not support the video tag.</video>"
  );
  $(".helpvideo video")[0].play();
});
$(".isdiscountavailablenewpricezi").click(function () {
  $(".helpSizeTop").css("display", "block");
});
$(".helpSizeTop>div>i").click(function () {
  $(".helpSizeTop").css("display", "none");
});
$('.newproductselectSizeDiv .new-product-inch').click(function(e){
  e.stopPropagation();
  $(this).prev().prev().click()
})
$(".newproductselectfirstchildSize").click(function (e) {
  e.stopPropagation();
  $('.materialxuanze1').css('display','none')
  var newproductselectdivSize = $(".newproductselectdivSize>div");
  if (newproductselectdivSize.length == 1) {
    return;
  }
  $(".materialxuanzeMaterial").css("display", "none");
  $(".forma2Select").css("border-radius", "15px");
  $('.format2Finish').css('border-radius','15px')
  if ($(".newproductselectdivSize").is(":visible")) {
    $(".newproductselectdivSize").css("display", "none");
    $(".newproductselectSize").css("border-radius", "15px");
  } else {
    var text = $(this)
      .text()
      .replace(/[^\d.]/g, "");
    var divlist = $(".newproductselectdivSize").children("div");
    divlist.map((re) => {
      $(divlist[re]).css("display", "block");
      if (
        $(divlist[re]).attr("class") &&
        $(divlist[re]).attr("class").indexOf("custom") < 0
      ) {
        if (
          text ==
          $(divlist[re])
            .attr("value")
            .replace(/[^\d.]/g, "")
        ) {
          $(divlist[re]).css("display", "none");
        }
      }
    });
    $(".newproductselectdivSize").css("display", "block");
    $(".newproductselectSize").css("border-radius", "15px 15px 0 0");
  }
  if (isProductType == 1) {
    $(".customSize").css("display", "none");
  }
  if ($(this).attr("waistposition")) {
    $(".active").css("display", "block");
  }
});
$(".newproductselectdivSize div").click(function (e) {
  e.stopPropagation();
  $(".newproductselectdivSize .active").removeClass("active");
  $('.newproductselectSize').css('border-radius','15px')
  $(this).addClass("active");
  if ($(this).attr("class") && $(this).attr("class").indexOf("custom") >= 0) {
    $(".newproductselectfirstchildSize").attr("value", "custom");
    editWidthHeight();
    if (newsize().width > 0 && newsize().height > 0) {
      cust();
    }
  } else {
    isdiy = false;
    pointerUpload();
    $(this).parent().prev().text($(this).attr("value"));
    $(this).parent().prev().attr("value", $(this).attr("value"));
    $(this).parent().css("display", "none");
    $(".newproductselectfirstchild").css("border-radius", "30px");
    if (
      $(".newproductselectfirstchildSize").attr("value").indexOf("custom") >= 0
    ) {
      $(".customSize").css("display", "block");
      $(".sizewidth").val("");
      $(".sizeheight").val("");
      $(".newpricez").text("");
      $(".isdiscountavailablenewpricezPrice").text("");
      $(".isdiscountavailable").text("");
      $(".newproductselectfirstchildQuantity span").remove();
      $(
        ".newproductselectfirstchildQuantity .newproductselectdivQuantityp"
      ).text("");
      $(".newproductselectdivQuantity").css("pointer-events", "none");
    } else {
      // $('.customSize').css('display','none')
      cust();
    }
    $(".newproductselectfirstchildSize").attr(
      "waistposition",
      $(this).children(".calendarWaistposition").text()
    );
  }
});
function edittipJustHolidayNew(price){
  var dicount = getProductCoefficient(true);
  var dicountCode=0.75
  if($('.arrayzCodes').text()=='Refresh15'){
    dicountCode=0.85
  }
  $('.tip-just-holidayNew').html('Pay <i>'+monetaryUnit.unit+newCurrency(price * dicount, 1)+'</i> with')
}$(".tipJustHoliday>i").click(function () {
  $(".tipJustHoliday div").css("display", "block");
});
$(".tipJustHoliday div i").click(function () {
  $(".tipJustHoliday div").css("display", "none");
});
$(".newproductselectdivQuantity>div").click(function (e) {
  e.stopPropagation();
  restorativeState()
  if ($(this).hasClass("active")) {
    return;
  }
  //     if(document.body.clientWidth < 750){
  // $(this).parent().css('display','none')
  //     }
  $(".newproductselectdivQuantity .active").removeClass("active");
  $(this).addClass(" active");
  if ($(this).text().indexOf("custom") >= 0) {
    $(this).parent().prev().html("custom");
    // $(this).parent().prev().find('.customQuantitysale').remove()
  } else {
    $(this).parent().prev().html($(this).html());
  }
  if (
    $(this).text().indexOf("custom") >= 0 &&!($(".customQuantitysale").val() > 0)
  ) {
    $(".customQuantity").css("display", "block");
    $(".newpricez").text("");
    $(".isdiscountavailablenewpricezPrice").text("");
    $(".isdiscountavailable").text("");
    $(".newproductselectfirstchildQuantity span").remove();
    $(".newproductselectfirstchildQuantity .newproductselectdivQuantityp").text(
      ""
    );
    var price = responsedatalist[responsedatalist.length - 1];
    var COUPON = {
      us: {
        limit: 79,
        reduce: 20,
        enabled: false,
        discountPrice: price.price,
        currency: { us: "$", ca: "CA$" }[region],
      },
      ca: {
        limit: 120,
        reduce: 30,
        enabled: false,
        discountPrice: price.price,
        currency: { us: "$", ca: "CA$" }[region],
      },
    };
    /** 新年活动券，limit使用限制最低金额，reduce满减多少 */
    var NY20_COUPON = COUPON[region || "us"];
    if (price.price >= NY20_COUPON.limit) {
      NY20_COUPON.discountPrice = price.price - NY20_COUPON.reduce;
      NY20_COUPON.enabled = true;
    } else {
      NY20_COUPON.enabled = false;
    }
    Alpine.$data(document.querySelector("#main-prod-coupon")).show =
      NY20_COUPON.enabled;
    var coefficient = getProductCoefficient();
    $(".newpricez").text(monetaryUnit.unit + newCurrency(price.price * coefficient, 1));
    if (coefficient < 1) {
      $('.under-line-price').text(monetaryUnit.unit + newCurrency(price.price, 1,true));
    }
    if (NY20_COUPON.enabled) {
      Alpine.$data(document.querySelector("#main-prod-coupon")).price =
        newCurrency(NY20_COUPON.discountPrice, 1);
    } else {
      Alpine.$data(document.querySelector("#main-prod-coupon")).price =
        newCurrency(price.price, 1);
    }
    $(".isdiscountavailable").text(
      monetaryUnit.unit +
        newCurrency(price.price / price.saleNum, 1) +
        perlabels
    );
    newpricezOriginalnew(price.price);
    $(".isdiscountavailablenewpricezPrice").text(
      monetaryUnit.unit + newCurrency(price.price / 0.7, 1)
    );
    edittipJustHolidayNew(price.price)
    isdiy = false;
    pointerUpload();
  } else {
    var num = $(this).find(".newproductselectdivQuantityp").text().replace(/[^0-9.]/g, "");
    var COUPON = {
      us: {
        limit: 79,
        reduce: 20,
        enabled: false,
        discountPrice: num,
        currency: { us: "$", ca: "CA$" }[region],
      },
      ca: {
        limit: 120,
        reduce: 30,
        enabled: false,
        discountPrice: num,
        currency: { us: "$", ca: "CA$" }[region],
      },
    };
    /** 新年活动券，limit使用限制最低金额，reduce满减多少 */
    var NY20_COUPON = COUPON[region || "us"];
    if (num >= NY20_COUPON.limit) {
      NY20_COUPON.discountPrice = num - NY20_COUPON.reduce;
      NY20_COUPON.enabled = true;
    } else {
      NY20_COUPON.enabled = false;
    }
    Alpine.$data(document.querySelector("#main-prod-coupon")).show =
      NY20_COUPON.enabled;
    var coefficient = getProductCoefficient();
    $(".newpricez").text(monetaryUnit.unit + newCurrency(num * coefficient, 1));
    if (coefficient < 1) {
      $('.under-line-price').text(monetaryUnit.unit + newCurrency(num, 1,true));
    }
    if (NY20_COUPON.enabled) {
      Alpine.$data(document.querySelector("#main-prod-coupon")).price =
        newCurrency(NY20_COUPON.discountPrice, 1);
    } else {
      Alpine.$data(document.querySelector("#main-prod-coupon")).price =
        newCurrency(num, 1);
    }
    $(".customQuantity").css("display", "none");
    if ($(this).text().indexOf("custom") >= 0) {
      $(".isdiscountavailable").text(
        monetaryUnit.unit +
          newCurrency(num / $(".customQuantitysale").val(), 1) +
          perlabels
      );
    } else {
      $(".isdiscountavailable").text(
        monetaryUnit.unit +
          newCurrency(num / $(this).attr("value"), 1) +
          perlabels
      );
    }
    newpricezOriginalnew(num);
    $(".isdiscountavailablenewpricezPrice").text(
      monetaryUnit.unit + newCurrency(num / 0.7, 1)
    );
    edittipJustHolidayNew(num)
    isdiy = true;
    editUpload();
  }
  responsedatalist.map((re) => {
    if (re.saleNum == $(this).attr("value")) {
      updateVariantInfoobj.quoteId = re.id;
      updateVariantInfoobj.month = re.month;
      updateVariantInfoobj.code = re.code;
      updateVariantInfoobj.saleNum = re.saleNum;
    }
  });
  editExtrastickersli();
  // 新增如果点击输入框，输入框数量为空或者小于0，则清空价格
  if ($(this).text().indexOf("custom") >= 0) {
    if($('.newproductselectdivQuantity .customQuantitysale').val()<=0){
      $('.newpricez').text('')
      $('.under-line-price').text('')
    }
  }
});
$(document).on("keydown", function (e) {
  if (e.which === 27) {
    isInstructionsTip = false;
    $(".uploadProp .coloe").click();
  }
});
$(".mobileExpand").click(function () {
  $(".newproductselectdiv>div").css("display", "block");
  $(this).css("display", "none");
});
$(".backgroundImgLeft").click(function () {
  var index = $(".thumbnail[aria-current]").parent().index();
  var thumbnail = $(".thumbnail-list li");
  $(".slider-button:first-child").click();
  $(thumbnail[index > 0 ? index - 1 : thumbnail.length - 1])
    .children("button")
    .click();
});
$(".backgroundImgRight").click(function () {
  var index = $(".thumbnail[aria-current]").parent().index();
  var thumbnail = $(".thumbnail-list li");
  $(".slider-button:last-child").click();
  $(thumbnail[index < thumbnail.length - 1 ? index + 1 : 0])
    .children("button")
    .click();
});
$(".product-new-bannerButtons").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".product-new-banner").height(),
    },
    1000
  );
});
$(".side-choose-btn span").click(function () {
  $(".side-choose-btn .active").removeClass("active");
  $(this).addClass("active");
});
$(".product-form__error-message-wrapper").click(function () {
  $(".product-form__error-message-wrapper").css("display", "none");
});
$(".Rounded-Corneroverviewall111newProduct").insertBefore(
  ".Rounded-Corneroverviewall111"
);

/////////////////////// upload modal gen2
var stickersCutLineBuutonClick = function () {
  $(".stickers-cut-line-button-group").click(function () {
    document.querySelectorAll(".stickers-cut-line-button-area").forEach((e) => {
      $(e).toggleClass("stickers-cut-line-active");
    });
    var index = $(".stickers-cut-line-active").index();
    var changeCutLineFuns = [startDieCut, sureDieCut];
    changeCutLineFuns[index]();
  });
};
stickersCutLineBuutonClick();

var artwork_upload_element;
if (document.querySelector) {
  artwork_upload_element = document.querySelector('[name="artwork_upload"]');
} else {
  var artwork_upload_elements = document.getElementsByName("artwork_upload");
  artwork_upload_element = artwork_upload_elements[0];
}
if (artwork_upload_element) {
  artwork_upload_element.addEventListener("click", function () {
    sendGAEvent("artwork_upload_click", {
      button_name: "artwork_upload",
      category: "user_action",
      label: "artwork_upload_click",
    });
    gtag_report_conversion();

  });
}

function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  if (!window.gtag) return
  window.gtag('event', 'conversion', {
      'send_to': 'AW-11458615515/H5mTCKOQ-IoaENux8tcq',
      'event_callback': callback
  });
  window.gtag('event', 'conversion', {
      'send_to': 'AW-11458615515/xrPFCIG3i6MaENux8tcq',
      'event_callback': callback
  });
  return false;
}

function getProductCoefficient(discountOnDiscount) {
  var discountCoefficient = $('.product__titleDiscountSpan').attr('discountamount')?(100 - $('.product__titleDiscountSpan').attr('discountamount'))/100: 1;
  var dicountCode=0.75
  if($('.arrayzCodes').text()=='Refresh15'){
    dicountCode=0.85
  }
  var globalDicount = dicountCode;
  return discountOnDiscount
    ? discountCoefficient * globalDicount
    : discountCoefficient;
}
if(window.innerWidth<750){
  window.addEventListener('scroll', function() {
    // 获取页面滚动距离
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop-100;
    var top=$('.collection__title-new').offset().top
      if(scrollTop>top){
        $('.new-product-addtab-rff').css('position','initial')
      }else{
        $('.new-product-addtab-rff').css('position','sticky')
      }
  });
}